module.exports = __webpack_public_path__ + "static/media/emojis_19.81b1e72b.svg";